import React from 'react'
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import leftarrow from "../../../../assets/images/left-arrow.svg";
import fileuploadpopup from "../../../../assets/images/fileuploadpopup.svg";
import ViewSpecialInfo from "./viewSpecialInfo.jsx";
import styles from './specialInformation.module.css';
const SpecialInformationsJsx = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    formData,
    changeHideState,
    onInputChangeHandler,
    onTouchHandler,
    formError,
    onSubmitButtonclick,
    specialInfoDetails,
    onDeleteButtonClick,
    editParticularSpecialization
  } = props;

  let verifyExpertID = localStorage.getItem('VerifyExpertID');
  const verificationInfo = localStorage.getItem('verificationStatus');
  const removeId = () => {
    const adminToken = localStorage.getItem('adminOldToken');

    localStorage.removeItem("expertId")
    localStorage.setItem("token", JSON.stringify(adminToken));
    localStorage.removeItem("adminOldToken")
    localStorage.removeItem("resumeOnBoard")
    localStorage.removeItem("isRemoveState")


    history.goBack()
  }
  const isNormalExpert = localStorage.getItem("resumeOnBoard")


  return (
    <>
      <section className="mainloginscreen expertregistrationnew">
        <div className="container">
          <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails}`}>
              <div className="detailsleft plaindetailsleft  d-flex align-items-center justify-content-center">
                <div className="back_btn" onClick={() => isNormalExpert ? removeId() : history.goBack()}>
                  <img src={leftarrow} alt={' '} />
                </div>
                <h1>Specialization Information</h1>
              </div>
              <div className="numberingwizerd">
                <ul className="d-flex align-items-center justify-content-center ">
                  <li>1</li>
                  <li className="active">2</li>
                  <li>3</li>
                  <li>4</li>
                </ul>
              </div>
            </div>

          </div>
          <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
              <h1 className="h2_style font-weight-bold">{t("EXPERT_SPECIAL.Specialization")}</h1>
              <h5 className="h5_style">{t("EXPERT_SPECIAL.Specialization_tag1")}</h5>
              <h5 className="h5_style">{t("EXPERT_SPECIAL.Specialization_tag2")}</h5>
              <h5 className="h5_style">{t("EXPERT_SPECIAL.Specialization_tag3")}</h5>


            </div>
            <div className={`${styles.institutelogintext}`}>
            {specialInfoDetails?.length ?
                <ViewSpecialInfo
                  specialInfoDetails={specialInfoDetails}
                  changeHideState={changeHideState}
                  onDeleteButtonClick={onDeleteButtonClick}
                  editParticularSpecialization={editParticularSpecialization}
                /> :
                <>

                  <div className={`${styles.expertfileupload}`}>
                    <div className="button_outerlogo">
                      <div className="btn_uploadlogo" onClick={() => changeHideState(true)}><img src={fileuploadpopup} alt={' '} /></div>
                    </div>
                    <h5 className="text-center h5_style">{t("EXPERT_SPECIAL.Specialization_add")}</h5>
                    <p className="text-center">{t("EXPERT_SPECIAL.Specialization_add1")}</p>
                    <p className="text-center">{t("EXPERT_SPECIAL.Specialization_add2")}</p>
                  </div>
                </>
              }
              <div className="mb-4 input-container form-group">
              {verificationInfo === "unVerified" ? <label>Description</label>
                  : <label>Description *</label>
                }
                <textarea className={`input form-control ${styles.descriptiontextarea}`} placeholder=" "
                  name="description"
                  value={formData.description}
                  onChange={onInputChangeHandler}
                  onBlur={onTouchHandler}
                  maxLength={500}
                ></textarea>
                {verificationInfo === "unVerified" ? null : <span className="text-danger">
                  {formError['description'] &&
                    (formError['description'] === "req"
                      ? 'description is required'
                      : '')}
                </span>}

                
              </div>
             
           
            

             
            </div>
            <div className="d-flex justify-content-center pb-4">
            {verificationInfo === "unVerified" ? <button disabled={specialInfoDetails?.length === 0} onClick={() => onSubmitButtonclick()} type="submit" className="mainbutton">{verifyExpertID ? 'Verify Now' : 'Next'}</button>

: <button disabled={!formData.description || specialInfoDetails?.length === 0} onClick={() => onSubmitButtonclick()} type="submit" className="mainbutton">{verifyExpertID ? 'Verify Now' : 'Next'}</button>
}
         </div> </div>
        </div>
      </section>
    </>

  );
};

export default SpecialInformationsJsx;